/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-02-01 09:15:05
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-09 17:12:41
 */
import React, { Fragment } from 'react'
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import jsplumb from 'jsplumb';
import * as tools from './tools';
import './index.css'
import axios from 'axios';
import $, { param } from 'jquery'
import CustomModal from '../../components/CustomModal';
import { message, Button, Collapse, Pagination, Input, Modal, Cascader } from 'antd';
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';
import Header2 from '../../Header/Header2';
import Header4 from '../../Header/Header4';
import Step2detail1 from '../GeovisResource/components/ProductOrdersStep/step2detail1'
import closeIcon from "./img/icon-close.png";
import iconserach from './img/icon-serach.png';
import {SearchOutlined} from '@ant-design/icons';
import { algProduceTypeOptionsSimple } from "src/components/Pages/AlgorithmModalAndTools/components/publicData.js"

let jsPlumbIn = jsplumb.jsPlumb;
var firstload = true
const headeroffect = 64
// jsPlumbIn.bind  事件单点击了连接线, 
// connection
// connectionDetached
// connectionMoved
// click  //单击
// dblclick  //双击
// endpointClick
// endpointDblClick
// contextmenu
// beforeDrop //连接前
// beforeDetach //断开连接前
// zoom
// Connection Events
// Endpoint Events
// Overlay Events
// Unbinding Events
//基本连接线样式
var connectorPaintStyle = {
    stroke: 'rgba(0, 114, 229, 1)',//连接线颜色
    joinstyle: "round",
    outlineStroke: "none",
    strokeWidth: 2
};

// 鼠标悬浮在连接线上的样式
var connectorHoverStyle = {
    // outlineStroke: 'red',
    strokeWidth: 3
};

//端点样式
let pointStyle = {
    fill: 'transparent',
    stroke: '#005FC0',
    strokeWidth: 2
}

//端点悬浮样式
let pointHoverStyle = {
    outlineStroke: 'lightblue'
}

//右边连接点（源） 属性
let sourcePoint = {
    isSource: true,
    isTarget: false,
    connector: ['Flowchart', { gap: 10, cornerRadius: 8, alwaysRespectStubs: true }],
    connectorStyle: connectorPaintStyle,//连接线的颜色，大小样式
    connectorHoverStyle: connectorHoverStyle,// 鼠标悬浮在连接线上的样式
    endpoint: ["Dot", {
        // cssClass: "myEndpoint",
        radius: 6,
    }],//端点
    paintStyle: pointStyle,//端点样式
    hoverPaintStyle: pointHoverStyle,//端点样式hover
    maxConnections: -1,
    connectorOverlays: [//线路径 配置
        ['PlainArrow', { //加了个普通箭头
            width: 16,
            length: 16,
            location: 1,
            // fill:'rgba(0, 114, 229, 1)',
            // events: {
            //     click: function (labelOverlay) {
            //         console.log(labelOverlay)
            //     }
            // }
        }],
    ]

}

//左边连接点（目标） 属性
let targetPoint = {
    isSource: false,
    isTarget: true,
    connector: ['Flowchart'],
    connectorStyle: connectorPaintStyle,//连接线的颜色，大小样式
    connectorHoverStyle: connectorHoverStyle,// 鼠标悬浮在连接线上的样式
    endpoint: ["Dot", {
        // cssClass: "myEndpoint",
        radius: 6,
    }],
    paintStyle: pointStyle,
    hoverPaintStyle: pointHoverStyle,
    maxConnections: -1
}

//节点（组件）属性
let itemcontainer = {
    containment: '#process-editor-panel',
    // grid: [26, 26]
}


Array.prototype.remove = function (val) {
    var index = this.indexOf(val);
    if (index > -1) {
        this.splice(index, 1);
    }
};

class ProcessDesign extends React.Component {
    // contextMenuRef = React.createRef();
    state = {
        topTypeSelect: 1,
        select: 1,//1表示选了 '组件' 2表示 '我的流程'
        tooltabactive: 1,
        microwaveTooltabactive: 1,
        processData: [],//存放了自定义流程的各个组件及组件信息
        // tools: defaulttools,
        compontentList: [
            { name: 'Inputs', type: 'common', toolId: 0, description: "" },
            { name: 'Outputs', type: 'common', toolId: 1, description: "", },
        ],
        tools: [
            { name: 'Inputs', type: 'common', toolId: 0, description: "" },
            { name: 'Outputs', type: 'common', toolId: 1, description: "", },
        ],//未分类前所有的算法组件
        algorithmTools: [],//分类后的所有算法组件
        showTools: [],//当前展示的所有算法组件
        classSelectIndex: 0, //当前选中算法类别
        typeSelectIndex: 0, //当前选中算法类别类型
        nowSelectToolsPageIndex: 1,//当前选中算法类别类型页数
        limitCount: 15,

        pageNo: 1,
        total: 0,

        rightclickitem: {},
        contextmenuopen: false,
        attributeopen: false,
        zoom: 1,

        firstMypro: [],
        dragable: false,

        toolpanel_current_page_level3: 1,//工具面板的当前页数
        toolpanel_current_page_level4: 1,//工具面板的当前页数
        current_node_name: "",//当前操作的结点

        //连接其他库和接口的数据存储
        mypro: [],//我的流程
        publicpro: [],//公共流程
        standardpro: [],//标准流程
        showPro: [], //所有流程检索后展示的列表，

        // loadStandardWorkflowPro: [],//读取到的所有标准流程
        // loadMyWorkflowPro: [],//读取到的所有自定义流程
        // loadPublicWorkflowPro: [],//读取到的所有公共流程
        allAlgorithmOnline: [],//所有读取到的算法
        nowClickMyWorkflowPro: {},//当前点击编辑的自定义流程

        publishModalFlag: false,
        deleteProModalFlag: false,
        loadingFlag: true,
        AlgorithmFlag: false,//算法详情面板显示
        AlgorithmDetails: {},//算法详情内容
        searchValue: '',
        searchAssembly: '',

        author: "wx",
        flowDesc: "1",
        flowLevel: "1",
        flowName: "wx",
        flowType: "1",
        flowVersion: "1.0",
        proChsName: "1",
        proClass: "1",
        proDesc: "1",
        proLevel: "1",//默认产品级别
        proName: "1",
        proVersion: "1",
        saveModalFlag: false,
        flowChsName: "",
        flowEngName: "",

        tipTools: [],//可用的tool提示
        activeKeyOne:[2],
        activeKeyTwo:[0],
        variety:[],//产品品种
    }

    componentDidMount() {
        // if (!firstload) {
        //     return
        // }
        // firstload = false
        // this.loadProcessByAxios("blank");
        // this.loadStandardProcessByAxios("blank");
        // this.loadPublicProcessByAxios("blank");
        this.loadAllAlgorithmOnline();
        let _this = this;
        jsPlumbIn.bind('contextmenu', function (conn, originalEvent) {
            _this.onContextMenu(conn, { x: originalEvent.clientX, y: originalEvent.clientY }, 'connectline')
        })

        // 连接成功
        jsPlumbIn.bind('connection', function (conn, originalEvent) {
            let sourceId = conn.sourceId;
            let targetId = conn.targetId;
            let { processData } = _this.state

            processData.forEach((n) => {
                if (n.uuid === sourceId) {          //保证定制流程为一条以input开始、output结束的线性流程
                    // n.targetNodes.push(targetId)
                    n.targetNodes = [targetId];
                }
            })

            _this.setState({ processData })
        })

        // 断开连接后
        jsPlumbIn.bind('connectionDetached', function (conn, originalEvent) {

        })
        // 跟换连接，在beforeDrop之后 connect之前
        jsPlumbIn.bind('connectionMoved', function (conn, originalEvent) {
            console.log('connectionMoved')
        })
        jsPlumbIn.bind('endpointClick', function (conn, originalEvent) {
            console.log('endpointClick')
        })
        //试图  手动 连接前
        jsPlumbIn.bind('beforeDrop', function (conn, originalEvent) {
            console.log('beforeDrop')
            return true
        })
        jsPlumbIn.bind('beforeDetach ', function (conn, originalEvent) {
            console.log('beforeDetach')
        })
        jsPlumbIn.bind('zoom ', function (conn, originalEvent) {
            console.log('zoom')
        })
        jsPlumbIn.ready(function () {

        })
        // 禁止拖拽断开连接
        jsPlumbIn.importDefaults({
            ConnectionsDetachable: false
        })
        //获取标准流程
        this.loadTempProcess(1)
        //获取公共流程
        this.loadPublicProcess(1)
        //获取个人流程
        this.loadPersonalProcess(1)
    }

    componentDidUpdate(prevProps, prevState) {
        const { user } = this.props;
        let scale = this.state.zoom
        document.getElementById('process-editor').style.zoom = scale
        jsPlumbIn.setZoom(scale);

        if (this.props.zd_user.id !== prevProps.zd_user.id) {
            //获取标准流程
            this.loadTempProcess(1)
            //获取公共流程
            this.loadPublicProcess(1)
            //获取个人流程
            this.loadPersonalProcess(1)
        }
        if (user.name !== prevProps.user.name) {
            this.setState({
                author: user.userName,
                flowDesc: "",
                flowLevel: "1",
                flowName: "",
                flowType: "",
                flowVersion: "1.0",
                proChsName: "",
                proClass: "",
                proDesc: "",
                proLevel: "1",//默认产品级别
                proName: "",
                proVersion: "",
                saveModalFlag: false,
                flowChsName: "",
            })
        }
    }

    componentWillUnmount() {
        jsPlumbIn.destroy();    //使用这个之后，第二次加载本组件能够继续正常运行，但新机器可能需要修改node包内一处代码(如果jsplumb没有更新的话)，位于jsplumb.js 4504行，将'_containerDelegations.length = 0;'改为'_containerDelegations=[];'
    }

    onContextMenu = (target, position, type) => {
        // let ele = this.contextMenuRef.current;
        let ele = ReactDOM.findDOMNode(this.contextmenu)
        ele.style.left = position.x + 'px'
        ele.style.top = position.y - headeroffect + 'px'
        this.setState({
            rightclickitem: { element: target, type: type },
            contextmenuopen: true,
            current_node_name: target.name//保存正在编辑的结点的名字
        });
    }

    dropitem = (e) => {
        e.preventDefault();
        let _this = this;
        let file = e.dataTransfer.files[0];
        let panel = document.getElementById('process-editor');
        let pl = panel.offsetLeft;
        let pt = panel.offsetTop;
        if (file) {
            let fileReader = new FileReader();
            fileReader.onload = function () {
                _this.loadProcess(this.result)
            }
            fileReader.onerror = function () {
                alert("读取失败");
            }
            fileReader.readAsText(file);
            return
        }

        if (this.state.draggingtool === null) {
            return
        }
        // console.log('拖入了' + this.state.draggingtool)
        // console.log('pl' + pl + 'pt:' + pt);
        // console.log(e.currentTarget)
        let { tools } = this.state
        let node = new ProcessNode()
        node.toolId = this.state.draggingtool.toolId
        node.left = (e.clientX - 564 - 50) / this.state.zoom - pl + 'px'
        node.top = (e.clientY - 130 - 50) / this.state.zoom - pt + 'px'
        node.uuid = 'node-' + node.toolId + '-' + new Date().getTime()
        let toolinfo = this.state.draggingtool
        node.name = toolinfo.name;
        node.type = toolinfo.type;
        node.dataSource = toolinfo.dataSource;
        this.addnode(node);
    }

    loadProcess = (processData) => {
        // processData = [{ "deleted": false, "targetNodes": ["node-4-1612495625269"], "toolId": 4, "left": "125px", "top": "257px", "uuid": "node-4-1612495616459", "name": "滤值均波", "type": "level3" }, { "deleted": false, "targetNodes": ["node-4-1612495626220"], "toolId": 4, "left": "391px", "top": "250px", "uuid": "node-4-1612495625269", "name": "滤值均波", "type": "level3" }, { "deleted": false, "targetNodes": [], "toolId": 4, "left": "638px", "top": "341px", "uuid": "node-4-1612495626220", "name": "滤值均波", "type": "level3" }, { "deleted": false, "targetNodes": ["node-4-1612495616459"], "toolId": 3, "left": "174px", "top": "545px", "uuid": "node-3-1612495634307", "name": "影像表现反射库", "type": "level3" }]
        this.clearJsplumb()

        if (typeof processData == 'string') {
            processData = JSON.parse(processData)
        }
                // console.log('删除后再次编辑加载数据:', processData)
                //添加节点
        processData.forEach((node) => {
            this.addnode({
                ...node
            })
        })
        setTimeout(() => {//添加连线
                    // let { processData } = this.state
            processData.forEach((node) => {
                    node.targetNodes.forEach((targetId) => {
                            // console.log('ceshiconnect', node, targetId)

                    this.addconnect(node.id, targetId)
                })
            })
        }, 100)
    }

    //仅读取本地缓存----连接workflow接口后则无法直接使用
    editMyPro = (pro) => {
        this.loadProcess(pro.content);
    }
    //目前workflow读取流程的方法，从flowID获取到流程节点布置，即上传的默认content格式数据
    editMyProByWorkflow = (pro) => {
        console.log("editMyProByWorkflow", pro)
        const { user } = this.props;
        let sendData = {
            flowId: pro.flowid,
        }
        // axios.post(global.url.workflow + `/static/applicationTool/onloadFlowC`, sendData
        axios.get(global.url.workflow + `/workflow/onloadFlow?flowId=${pro.flowid}`
        ).then(res => {
            if (res.data.code === "200") {
                let data = res.data.payload;
                console.log("editMyProByWorkflow---", data);
                if (data.relations.length === 0) {          //临时判断，之后可以考虑优化
                    message.error("该流程非正常流程，无法加载流程图！");
                    return;
                }
                // if (this.state.select === 2) {
                //     message.info("标准流程暂时无法查看！");
                //     return;    //暂时不允许查看标准流程
                // }
                let nodeList = this.returnNodeListFromRelations(data.relations);
                if (nodeList.length === 0) {    //临时判断，之后可以考虑优化
                    message.error("该流程非正常流程，无法加载流程图！");
                    return;
                }
                this.loadProcess(nodeList);
                if (user.userId === pro.userID) {
                    this.setState({ flowChsName: pro.flowChsName })
                }
                this.setState({ nowClickMyWorkflowPro: pro })
            } else {
                message.error("流程读取失败，请检查网络连接……")
            }
        }).catch((e) => {
            message.error("流程读取失败，请检查网络连接……")
            console.log('流程读取失败，请检查网络连接', e);
        })
    }
    //根据Relations生成流程图
    returnNodeListFromRelations = (relations) => {
        try {
            if (relations.lenght === 0) {//临时判断，之后可以考虑优化
                message.error("该流程非正常流程，无法加载流程图！");
                return;
            }
            let nodeList = [];
            let trueRelaTions = [];
            let flag = true;
            let nextNode = "Inputs";

            let count = 0;
            let limitCount = 1000;
            let limitFlag = false;
            while (flag) {
                relations.map((relation) => {
                    if (trueRelaTions.length === relations.length) return;
                    if (relation.dependAlg === nextNode) {
                        trueRelaTions.push(relation);
                        nextNode = relation.algName;
                    }
                    if (relation.algName === "Outputs" && trueRelaTions.length === relations.length) flag = false;
                })
                if (count >= limitCount && trueRelaTions.length === 0) {//临时判断，之后可以考虑优化
                    limitFlag = true;
                    flag = false;
                }
            }
            if (limitFlag) {//临时判断，之后可以考虑优化
                message.error("该流程非正常流程，无法加载流程图！");
                return;
            }
            console.log("trueRelaTions--trueRelaTions", trueRelaTions);
            let leftPx = 1200;
            let limitLeft = 250;
            let timeNumber = new Date().getTime();
            trueRelaTions.map((relation, index) => {
                if (relation.dependAlg === "Inputs") {
                    nodeList.push({
                        "id": `node-${0}-${timeNumber}`,
                        "targetNodes": [
                            `node-${relation.algName}-${timeNumber}`
                        ],
                        "toolId": 0,
                        "left": `${leftPx}px`,
                        "top": "1235px",
                        "uuid": `node-${0}-${timeNumber}`,
                        "name": "Inputs",
                        "type": "common",
                        "deleted": false,
                    });
                }
                let nextNode = trueRelaTions[index + 1];
                let nextNodeId = `node-${1}-${timeNumber}`
                if (nextNode && nextNode.algName !== "Outputs") nextNodeId = `node-${nextNode.algName}-${timeNumber}`
                if (relation.algName !== "Outputs") {
                    nodeList.push({
                        "id": `node-${relation.algName}-${timeNumber}`,
                        "targetNodes": [
                            nextNodeId
                        ],
                        "toolId": relation.algName,
                        "left": `${leftPx + limitLeft * (index + 1)}px`,
                        "top": "1200px",
                        "uuid": `node-${relation.algName}-${timeNumber}`,
                        "name": relation.algName,
                        "type": "level3",
                        "deleted": false,
                        dataSource: this.returnInfoFormAlgName(relation.algName),
                    });
                }
                if (relation.algName === "Outputs") {
                    nodeList.push({
                        "id": `node-${1}-${timeNumber}`,
                        "targetNodes": [],
                        "toolId": 1,
                        "left": `${leftPx + limitLeft * (index + 1)}px`,
                        "top": "1235px",
                        "uuid": `node-${1}-${timeNumber}`,
                        "name": "Outputs",
                        "type": "common",
                        "deleted": false
                    });
                }
            })
            console.log("trueRelaTions--nodeList", nodeList);
            return nodeList;
        } catch (error) {
            message.error(error)
            // console.log('ceshi', error)
        }

    }

    //根据算法名返回算法所有信息
    returnInfoFormAlgName = (algName) => {
        const { allAlgorithmOnline } = this.state;
        console.log("returnInfoFormAlgName", algName, allAlgorithmOnline);
        let dataSource = {};
        allAlgorithmOnline.map((alg) => {
            if (alg.algorithmName === algName)
                dataSource = alg;
        })
        if (Object.keys(dataSource).length)
            return dataSource;
        else {
            throw '线上未找到匹配算法'
        }
    }

    //从自定义流程（个人流程）发布到公共流程
    publishMyPro = () => {
        console.log("this.state.nowClickMyWorkflowPro", this.state.nowClickMyWorkflowPro);
        let sendData = {
            flowId: this.state.nowClickMyWorkflowPro.flowID,
        }
        // axios.post(global.url.workflow + `/static/applicationTool/publishWorkflow2`, sendData
        axios.get(global.url.workflow + `/workflow/publishPublicWorkflow?flowId=${this.state.nowClickMyWorkflowPro.flowid}&ispublic=true`,
        ).then(res => {
            // console.log("publishMyPro-----", res);
            if (res.data.code === "200") {
                message.success("公共流程发布成功！");
                let data = res.data;
                // this.loadPublicProcessByAxios("blank");
                this.loadPublicProcess(1)
                this.setState({ publishModalFlag: false });
            } else {
                message.error("算法读取失败，请检查网络连接……");
                this.setState({ publishModalFlag: false });
            }
        }).catch((e) => {
            message.error("算法读取失败，请检查网络连接……")
            console.log(e);
            this.setState({ publishModalFlag: false });
        })
    }
    //从自定义流程（个人流程）发布到标准流程
    // publishStandardPro = (flowId) => {
    //     let sendData = {
    //         // flowId: this.state.nowClickMyWorkflowPro.flowID,
    //         flowId: flowId
    //     }
    //     axios.post(global.url.workflow + `/static/applicationTool/publishWorkflow`, sendData
    //     ).then(res => {
    //         // console.log("publishMyPro-----", res);
    //         if (res.status === 200) {
    //             message.success("标准流程保存成功！");
    //             let data = res.data;
    //             this.loadStandardProcessByAxios("blank");
    //             this.setState({ publishModalFlag: false });
    //         }
    //         else {
    //             message.error("算法读取失败，请检查网络连接……");
    //             this.setState({ publishModalFlag: false });
    //         }
    //     }).catch((e) => {
    //         message.error("算法读取失败，请检查网络连接……")
    //         console.log(e);
    //         this.setState({ publishModalFlag: false });
    //     })
    // }
    //打开发布流程
    openPublishModal = (pro) => {
        this.setState({ publishModalFlag: true, nowClickMyWorkflowPro: pro })
    }
    //打开删除流程
    deleteProModal = (pro) => {
        this.setState({ deleteProModalFlag: true, nowClickMyWorkflowPro: pro })
    }

    //删除流程
    deleteWorkflowPro = () => {
        const { nowClickMyWorkflowPro } = this.state;
        let sendData = {
            flowId: nowClickMyWorkflowPro.flowID,
        }
        // axios.post(global.url.workflow + `/static/applicationTool/deleteWorkflow`, sendData
        axios.delete(global.url.workflow + `/workflow/delete?flowid=${nowClickMyWorkflowPro.flowid}`,
        ).then(res => {
            // console.log("deleteWorkflowPro-----", res);
            if (res.data.code === "200") {
                message.success("流程删除成功！");
                // this.loadProcessByAxios("blank");
                // this.loadStandardProcessByAxios("blank");
                // this.loadPublicProcessByAxios("blank");
                //获取标准流程
                this.loadTempProcess(1)
                //获取公共流程
                this.loadPublicProcess(1)
                //获取个人流程
                this.loadPersonalProcess(1)
            } else {
                message.error("流程删除失败，请检查网络连接……")
            }
            this.setState({ deleteProModalFlag: false, });
        }).catch((e) => {
            message.error("流程删除失败，请检查网络连接……")
            console.log(e);
            this.setState({ deleteProModalFlag: false, });
        })
    }

    //读取所有线上算法
    loadAllAlgorithmOnline = () => {
        message.info("算法组件加载中，请稍等……");
        // axios.post(global.url.workflow + `/static/applicationTool/onloadAlgTotal1`
        axios.get(global.url.workflow + `/workflow/onloadAlgTotal`
        ).then(res => {
            let temp = JSON.stringify(res.data)
            console.log('loadAllAlgorithmOnline', JSON.parse(temp))
            if (res.status === 200) {
                let data = res.data.payload;
                let commonTools = [
                    { name: 'Inputs', type: 'common', toolId: 0, description: "" },
                    { name: 'Outputs', type: 'common', toolId: 1, description: "", },
                ];
                data.map((allAlgorithm, index) => {
                    let temp = {
                        name: allAlgorithm.chsName,
                        type: "level3",
                        toolId: index + 2,
                        dataSource: allAlgorithm
                    };
                    commonTools.push(temp);
                });
                this.setState({
                    allAlgorithmOnline: [...data],
                    tools: [...commonTools],
                    algorithmTools: tools.returnAlgorithmTools(data),
                    loadingFlag: true,
                }, () => {
                    message.success("加载完成！");
                    console.log("algorithmTools", this.state.algorithmTools,this.state.tools);
                    this.changeLightTools(0);
                });
            } else {
                message.error("算法读取失败，请检查网络连接……")
            }
        }).catch((e) => {
            message.error("算法读取失败，请检查网络连接……")
            console.log(e);
        })
    }

    //使用数据库接口按照条件获取算法流程
    // isPubilc:"f"   非公共的
    // isPublic:"true" 公共的
    // istemp:"f" 非标准的
    // istemp:"z" 标准的
    //标准的一定是非公的，非标准的一定是公共的，
    //userid与当前用户userid相等的一定是个人的

    //获取标准流程
    loadTempProcess = async (pageNo, flowKeyword) => {
        let {variety} = this.state
        let query = ''
        if (flowKeyword === undefined) {
            // query = `dataBaseDocQueryUrl/api/getAllWorkFlow?flowKeyword=&pageNo=${pageNo}&pageNum=10&ispublic=&istemp=z&userid=`
            query = global.url.workflow + `/workflow/getAllTempWorkflow?flowchsname=&page=${pageNo}&limit=15&flowid=`
        } else {
            query = global.url.workflow + `/workflow/getAllTempWorkflow?flowchsname=${flowKeyword}&page=${pageNo}&limit=15&flowid=`
        }
        if(variety && variety.length > 0) {
            query = query + '&flowtype=' + variety[0] + '&productid=' + variety[1]
        }
        const { data: res } = await axios.get(query, {
            headers: {
                Authorization: this.props.zd_user.token
            }
        })

        // console.log("loadTempProcess",res)
        if (res.code === '200') {
            this.setState({
                standardpro: res.payload.list,
                total: res.payload.total,
                pageNo: pageNo
            })
        } else {
            message.error('标准流程获取失败!')
        }
        // res.data.
    }

    //获取所有公共流程
    loadPublicProcess = async (pageNo, flowKeyword) => {
        let {variety} = this.state
        let query = ''
        if (flowKeyword === undefined) {
            // query = `dataBaseDocQueryUrl/api/getAllWorkFlow?flowKeyword=&pageNo=${pageNo}&pageNum=10&ispublic=true&istemp=f&userid=`
            query = global.url.workflow + `/workflow/getAllPublicWorkflow?flowchsname=&page=${pageNo}&limit=15&flowid=`
        } else {
            query = global.url.workflow + `/workflow/getAllPublicWorkflow?flowchsname=${flowKeyword}&page=${pageNo}&limit=15&flowid=`
        }
        if(variety && variety.length > 0) {
            query = query + '&flowtype=' + variety[0] + '&productid=' + variety[1]
        }
        const { data: res } = await axios.get(query, {
            headers: {
                Authorization: this.props.zd_user.token
            }
        })

        // console.log(res)
        if (res.code === '200') {
            this.setState({
                publicpro: res.payload.list,
                total: res.payload.total,
                pageNo: pageNo
            })
        } else {
            message.error('公共流程获取失败!')
        }
    }

    //获取个人流程
    loadPersonalProcess = async (pageNo, flowKeyword) => {
        let {variety} = this.state
        const { user } = this.props;
        let query = ''
        if (flowKeyword === undefined) {
            // query = `dataBaseDocQueryUrl/api/getAllWorkFlow?flowKeyword=&pageNo=${pageNo}&pageNum=10&ispublic=true&istemp=f&userid=`
            query = global.url.workflow + `/workflow/myWorkflow?flowchsname=&page=${pageNo}&limit=15&userId=${user.userId}&flowid=`
            // query = global.url.workflow + `/workflow/myWorkflow?flowchsname=&page=${pageNo}&limit=10&flowid=`
        } else {
            query = global.url.workflow + `/workflow/myWorkflow?flowchsname=${flowKeyword}&page=${pageNo}&limit=15&userId=${user.userId}&flowid=`
        }

        if(variety && variety.length > 0) {
            query = query + '&flowtype=' + variety[0] + '&productid=' + variety[1]
        }
        const { data: res } = await axios.get(query, {
            headers: {
                Authorization: this.props.zd_user.token
            }
        })

        // console.log(res)
        if (res.code === '200') {
            this.setState({
                mypro: res.payload.list,
                total: res.payload.total,
                pageNo: pageNo
            })
        } else {
            message.error('公共流程获取失败!')
        }
    }

    //分页查询
    proPageChange = (pageNo) => {
        const { select } = this.state;
        if (select === 2) this.loadTempProcess(pageNo,this.state.searchValue)
        else if (select === 3) this.loadPersonalProcess(pageNo,this.state.searchValue)
        else this.loadPublicProcess(pageNo,this.state.searchValue)
    }

    //读取所有标准流程
    // loadStandardProcessByAxios = (keyword) => {
    //     let data = {
    //         flowkeyword: keyword,
    //         userId: this.props.user ? this.props.user.userId : "2000000081"
    //     }
    //     axios.post(global.url.workflow + `/static/applicationTool/getAllTempWorkflow`, data
    //     ).then(res => {
    //         console.log("loadStandardProcessByAxios-----", res);
    //         if (res.status === 200) {
    //             let data = res.data;
    //             // let nowMyPro = tools.returnMyPro(data);
    //             this.setState({
    //                 loadStandardWorkflowPro: [...data],
    //                 standardpro: [...data],
    //             });
    //         }
    //         else {
    //             message.error("自定义流程读取失败，请检查网络连接……")
    //         }
    //     }).catch((e) => {
    //         message.error("自定义流程读取失败，请检查网络连接……")
    //         console.log(e);
    //     })
    // }
    //读取所有自定义流程（个人流程）
    // loadProcessByAxios = (keyword) => {
    //     let data = {
    //         flowkeyword: keyword,
    //         userId: this.props.user ? this.props.user.userId : "2000000081"
    //     }
    //     axios.post(global.url.workflow + `/static/applicationTool/myWorkflow`, data
    //     ).then(res => {
    //         console.log("saveAxios-----", res);
    //         if (res.status === 200) {
    //             let data = res.data;
    //             // let nowMyPro = tools.returnMyPro(data);
    //             this.setState({
    //                 loadMyWorkflowPro: [...data],
    //                 mypro: [...data],
    //                 // mypro:[...nowMyPro],
    //             });
    //         }
    //         else {
    //             message.error("自定义流程读取失败，请检查网络连接……")
    //         }
    //     }).catch((e) => {
    //         message.error("自定义流程读取失败，请检查网络连接……")
    //         console.log(e);
    //     })
    // }
    //读取所有公共流程
    // loadPublicProcessByAxios = (keyword) => {
    //     let data = {
    //         flowkeyword: keyword,
    //     }
    //     axios.post(global.url.workflow + `/static/applicationTool/getAllPublicWorkflow`, data
    //     ).then(res => {
    //         console.log("saveAxios-----", res);
    //         if (res.status === 200) {
    //             let data = res.data;
    //             // let nowMyPro = tools.returnMyPro(data);
    //             this.setState({
    //                 loadPublicWorkflowPro: [...data],
    //                 publicpro: [...data],
    //                 // mypro:[...nowMyPro],
    //             });
    //         }
    //         else {
    //             message.error("自定义流程读取失败，请检查网络连接……")
    //         }
    //     }).catch((e) => {
    //         message.error("自定义流程读取失败，请检查网络连接……")
    //         console.log(e);
    //     })
    // }
    //点击某个自定义流程的编辑后，根据流程ID，去读取该流程对应的所有组件和布置，然后在画布上构建展示
    loadClickMyWorkflowPro = (clickData) => {
        let sendData = {
            flowId: clickData.flowID,
        }
        axios.post(global.url.workflow + `/static/applicationTool/onloadFlow`, sendData
        ).then(res => {
            console.log("saveAxios-----", res);
            if (res.status === "200") {
                let data = res.data;
                this.setState({ nowClickMyWorkflowPro: data });
            } else {
                message.error("自定义流程读取失败，请检查网络连接……")
            }
        }).catch((e) => {
            message.error("自定义流程读取失败，请检查网络连接……")
            console.log(e);
        })
    }

    /**
     * 把节点添加到视图中 ，包括添加到state里  ，这里来给元素添加称呼
     * @param {*} node
     */
    addnode = (node) => {
        console.log('检查node内容属性:', node);
        let { processData } = this.state
        // node.uuid = 'node-' + node.toolId + '-' + new Date().getTime()
        // if (!processData.find((n) => n.uuid === node.uuid)) {
        // node.id = node.uuid + '-' + new Date().getTime()
        node.id = node.uuid;
        processData.push(node)
        // console.log("addnode", processData);
        this.setState({ processData })
        // } else {
        //     window.location.reload()
        //     // jsPlumbIn.revalidate(node.uuid)
        // }

        this.initNode(node);
    }

    addconnect = (sourceId, targetId) => {
        // console.log('ceshi addconnect')

        jsPlumbIn.connect({ uuids: [sourceId + '-source', targetId + '-target'] })
        // jsPlumbIn.connect({ uuids: [sourceId, targetId] })
        // jsPlumbIn.connect({
        //     source: sourceId, // 源节点
        //     target: targetId, // 目标节点
        //     anchors: ["Right", "Left"],
        // })
    }

    dragstart = (tool) => {
        this.setState({ draggingtool: tool })
    }

    /**
     * 获取点击的结点
     */
    getNode = (node) => {
        let component;
        switch (node.type) {
            case 'common'://onContextMenu：右键点击事件
                component = <InOutNode node={node} key={node.id} onContextMenu={this.onContextMenu} />
                break;
            // case 'level3':
            //     component = <CommonNode node={node} onContextMenu={this.onContextMenu}></CommonNode>
            //     break;
            default:
                component = <CommonNode node={node} key={node.id} onContextMenu={this.onContextMenu} />
                break
        }
        return component;
    }

    /**
     * 初始化一个节点 ，为其添加连接点
     * @param {*} node
     */
    // initNode = (node: ProcessNode) => {
    //     var timer = setInterval(() => {
    //         let ele = document.getElementById(node.id)
    //         if (ele) {
    //             ele.style.left = node.left
    //             ele.style.top = node.top
    //             switch (node.toolId) {
    //                 case 0:
    //                     jsPlumbIn.addEndpoint(node.id, {
    //                         anchors: ['Right'],
    //                         uuid: node.uuid + '-source',
    //                         maxConnections: 1,           //端点最大连接数，因为目前为线性流程，所以全部设置为1
    //                     }, sourcePoint)
    //                     // console.log('创建右节点' + node.uuid + '-source')
    //                     break;
    //                 case 1:
    //                     jsPlumbIn.addEndpoint(node.id, {
    //                         anchors: ['Left'],
    //                         uuid: node.uuid + '-target',
    //                         maxConnections: 1,
    //                     }, targetPoint)
    //                     // console.log('创建左节点' + node.uuid + '-source')
    //                     break;
    //                 default:
    //                     jsPlumbIn.addEndpoint(node.id, {
    //                         anchors: ['Right'],
    //                         uuid: node.uuid + '-source',
    //                         maxConnections: 1,
    //                     }, sourcePoint)
    //                     jsPlumbIn.addEndpoint(node.id, {
    //                         anchors: ['Left'],
    //                         uuid: node.uuid + '-target',
    //                         maxConnections: 1,
    //                     }, targetPoint)
    //                     // console.log('创建左右节点' + node.uuid + '')
    //                     break
    //             }
    //             jsPlumbIn.draggable(node.id, itemcontainer)
    //             clearInterval(timer)
    //             timer = null
    //         } else {
    //             console.log(node.id + '还不存在！')
    //         }
    //     }, 1)
    // }
    initNode = (node) => {
        var timer = setInterval(() => {
            let ele = document.getElementById(node.id);
            // console.log('检查流程编辑报错:',ele);
            if (ele) {
                ele.style.left = node.left
                ele.style.top = node.top
                switch (node.toolId) {
                    case 0:
                        jsPlumbIn.addEndpoint(node.id, {
                            anchors: ['Right'],
                            uuid: node.uuid + '-source',
                            maxConnections: 1,           //端点最大连接数，因为目前为线性流程，所以全部设置为1
                        }, sourcePoint)
                        // console.log('创建右节点' + node.uuid + '-source')
                        break;
                    case 1:
                        jsPlumbIn.addEndpoint(node.id, {
                            anchors: ['Left'],
                            uuid: node.uuid + '-target',
                            maxConnections: 1,
                        }, targetPoint)
                        // console.log('创建左节点' + node.uuid + '-source')
                        break;
                    default:
                        let shouldDrawPoints = [];
                        node.dataSource.aPamas.map((params, index) => {
                            if (params.control === 'File' && (params.inputType === 'Satellite' || params.inputType === 'production')) {
                                shouldDrawPoints.push(params);
                            } else return
                        })
                        this.setTipTools(shouldDrawPoints)
                        let leftCount = 1 / (shouldDrawPoints.length + 1);
                        shouldDrawPoints.map((params, index) => {
                            jsPlumbIn.addEndpoint(node.id, {
                                // anchors: ['Left'],
                                anchors: [0, leftCount + index * leftCount, 0, 0],
                                uuid: node.uuid + '-target',
                                maxConnections: 1,
                                overlays: [
                                    ['Label', {
                                        label: params.paraName,
                                        id: node.uuid + '-targetLabel' + `-${index}`,
                                        location: [-1, 0],
                                        cssClass: "ProcessDesign_Endpoint_DotLabel"
                                    },]
                                ],
                            }, targetPoint)
                        })
                        let shouldDrawPoints_Output = [];

                        node.dataSource.outputs.map((params, index) => {
                            // if (params.control !== 'Tile' && params.control !== 'File' && params.control !== 'file') return;
                            shouldDrawPoints_Output.push(params);
                        })
                        let rightCount = 1 / (shouldDrawPoints_Output.length + 1);
                        shouldDrawPoints_Output.map((params, index) => {
                            jsPlumbIn.addEndpoint(node.id, {
                                // anchors: ['Right'],
                                anchors: [1, rightCount + index * rightCount, 0, 0],
                                uuid: node.uuid + '-source',
                                maxConnections: 1,
                                overlays: [
                                    ['Label', {
                                        label: params.paraName,
                                        id: node.uuid + '-sourceLabel' + `-${index}`,
                                        location: [-1, 0],
                                        cssClass: "ProcessDesign_Endpoint_DotLabel"
                                    }]
                                ]
                            }, sourcePoint)
                        })
                }
                jsPlumbIn.draggable(node.id, itemcontainer)
                clearInterval(timer)
                timer = null
            } else {
                // console.log(node.id + '还不存在！')
            }
        }, 1)
    }

    setTipTools = async (shouldDrawPoints) => {
        let resList = []
        // console.log('ceshi', shouldDrawPoints)
        for (let item of shouldDrawPoints) {
            if (item.inputType === 'Satellite') {
                resList.push({ name: 'Inputs', type: 'common', toolId: 0, description: "" })
            } else {
                let dateFromList = item.dateFrom.replace(';', '&algIds=')
                // console.log('ceshi', dateFromList)
                let res = await axios.get(global.url.workflow + `/workflow/onloadAlgTotal?algIds=${dateFromList}`)
                if (res.status === 200) {
                    let data = res.data.payload;
                    resList = [...resList, ...data]
                } else {
                    message.error("算法读取失败，请检查网络连接……")
                }
            }

        }

        this.setState({
            tipTools: tools.returnTipTools(resList),
        })

    }

    test = () => {
        console.log(this.state)
        let { processData, tools } = this.state
        console.log(JSON.stringify(processData))
    }

    //我的流程————检索
    pressSearch = () => {
        let { select, searchValue } = this.state

        if (select === 3) {
            //关键字查询我的流程
            this.loadPersonalProcess(1, searchValue)
        } else if (select === 4) {
            //关键字查询公共流程
            this.loadPublicProcess(1, searchValue)
        } else if (select === 2) {
            //关键字查询标准流程
            this.loadTempProcess(1, searchValue)
        }
    }
    
    assemblySearch = () => {
        let { searchAssembly, algorithmTools, compontentList, tipTools } = this.state
        if(searchAssembly.includes('通用组件') || searchAssembly.includes('输入') || searchAssembly.includes('输出')) {
            this.setState({
                activeKeyOne:[0]
            })
        }
        if(searchAssembly.includes('可用组件')) {
            this.setState({
                activeKeyOne:[1]
            })
        }
        for(let index=0;index<algorithmTools.length;index++) {
            let item = algorithmTools[index]
            if(item.className.includes(searchAssembly) || searchAssembly.includes(item.className)) {
                this.setState({
                    activeKeyOne: [index + 2]
                })
                break
            } else {
                for(let index1=0;index1<item.typeList.length;index1++) {
                    let item1 = item.typeList[index1]
                    if(item1.typeName.includes(searchAssembly) || searchAssembly.includes(item1.typeName)) {
                        this.setState({
                            activeKeyOne: [index + 2],
                            activeKeyTwo: [index1]
                        })
                        break
                    } else {
                        for(let index2=0;index2<item1.compontentList.length;index2++) {
                            let item2 = item1.compontentList[index2]
                            if(item2.name.includes(searchAssembly) || searchAssembly.includes(item2.name)) {
                                this.setState({
                                    activeKeyOne: [index + 2],
                                    activeKeyTwo: [index1],
                                })
                                break
                            }
                        }
                    }
                }
            }
        }
    }

    //保存为我的流程
    saveAxios = () => {
        let { processData, flowChsName, flowEngName } = this.state;
        if (flowChsName === "" && flowEngName === "") {
            message.error("流程名称不能为空！")
            return;
        }
        // if (this.state.select === 1 && this.isInMyWorkflow(flowChsName)) {
        //     message.error("该流程名称已存在，请使用其他命名！");
        //     return;
        // }
        let saveprocess = [];
        processData.forEach((node, index) => {
            let ele = document.getElementById(node.id);
            if (ele) {
                node.left = ele.style.left;
                node.top = ele.style.top;
                if (!saveprocess.find((n) => n.uuid === node.uuid))
                    saveprocess.push(node)
            }
        });
        saveprocess = this.returnSortContent(saveprocess);
        let data = {
            name: this.state.flowChsName,
            content: [...saveprocess],
        };
        let algLists = tools.returnAlgLists(this.state.allAlgorithmOnline, saveprocess);
        let workflowSave = tools.returnWorkflowSave(this, algLists, saveprocess);
        console.log("workflowSave", algLists, workflowSave);
        // return;
        axios.post(global.url.workflow + `/workflow/workflow`, workflowSave
        ).then(res1 => {
            console.log("workflow-----", res1.data);
            if (res1.data.code === "200" || res1.data.code === "1") {
                if (res1.data.code === "200")
                    message.success("流程保存成功！");
                else
                    message.success("流程更新成功！");
                // this.loadProcessByAxios("blank");
                this.loadPersonalProcess(1);
                this.setState({ saveModalFlag: false });
            } else {
                message.error("流程保存失败，请检查网络连接……")
                this.setState({ saveModalFlag: false });
            }
        }).catch((e) => {
            message.error("流程保存失败，请检查网络连接……")
            this.setState({ saveModalFlag: false });
            console.log(e);
        })
    }
    //保存为标准流程
    // saveAxios_standard = () => {
    //     let { processData, flowChsName } = this.state;
    //     if (flowChsName === "") {
    //         message.error("标准流程名称不能为空！")
    //         return;
    //     }
    //     let saveprocess = [];
    //     processData.forEach((node, index) => {
    //         let ele = document.getElementById(node.id);
    //         if (ele) {
    //             node.left = ele.style.left;
    //             node.top = ele.style.top;
    //             if (!saveprocess.find((n) => n.uuid === node.uuid))
    //                 saveprocess.push(node)
    //         }
    //     });
    //     saveprocess = this.returnSortContent(saveprocess);
    //     let data = {
    //         name: this.state.flowChsName,
    //         content: [...saveprocess],
    //     };
    //     let algLists = tools.returnAlgLists(this.state.allAlgorithmOnline, saveprocess);
    //     axios.post(global.url.workflow + `/static/applicationTool/saveAlgCompts`, algLists
    //     ).then(res => {
    //         console.log("saveAlgCompts-----", res.data);
    //         if (res.status === 200) {
    //             let workflowSave = tools.returnWorkflowSave(this, algLists, saveprocess);
    //             console.log("workflowSave", workflowSave);
    //             axios.post(global.url.workflow + `/static/applicationTool/workflow4`, workflowSave
    //             ).then(res1 => {
    //                 console.log("workflow-----", res1.data);
    //                 if (res1.data.code === 200 || res.data.code === 1) {
    //                     if (res1.data.code === 200) {
    //                         let flowData = workflowSave.workflowSave;
    //                         let flowId = flowData.flowName + flowData.flowVersion + workflowSave.userid;
    //                         this.publishStandardPro(flowId);
    //                     }
    //                     else
    //                         message.success("标准流程更新成功！");
    //                     this.loadStandardProcessByAxios("blank");
    //                     this.setState({ saveModalFlag: false });
    //                 }
    //                 else {
    //                     message.error("标准流程保存失败，请检查网络连接……")
    //                     this.setState({ saveModalFlag: false });
    //                 }
    //             }).catch((e) => {
    //                 message.error("标准流程保存失败，请检查网络连接……")
    //                 this.setState({ saveModalFlag: false });
    //                 console.log(e);
    //             })
    //         }
    //         else {
    //             message.error("标准流程算法保存失败，请检查网络连接……")
    //             this.setState({ saveModalFlag: false });
    //         }
    //     }).catch((e) => {
    //         message.error("标准流程算法保存失败，请检查网络连接……")
    //         console.log(e);
    //         this.setState({ saveModalFlag: false });
    //     })
    // }

    // isInMyWorkflow=(flowChsName)=>{
    //     const{loadMyWorkflowPro}=this.state;
    //     let flag = false;
    //     loadMyWorkflowPro.map((mypro)=>{
    //         if(mypro.flowChsName===flowChsName)
    //             flag=true;
    //     })
    //     return flag;
    // }

    breforeSave = () => {
        let { processData } = this.state;
        let checkFlag = true;
        let inputCount = 0;
        let outputCount = 0;
        let dataLength = processData.length;
        processData.forEach((node, index) => {
            if (node.deleted === false) {
                if (node.toolId === 0)
                    inputCount += 1;
                if (node.toolId === 1)
                    outputCount += 1;
                if (node.targetNodes.length !== 1 && node.toolId !== 1)
                    checkFlag = false;
                if (node.targetNodes.length !== 0 && node.toolId === 1)
                    checkFlag = false;
            }
        })
        if (inputCount !== 1 || outputCount !== 1) {
            checkFlag = false;
        }
        if (!checkFlag) {
            message.error("请确保每个端点都被连接，有且仅有一个input和output组件！");
            console.log("processData", processData, checkFlag, inputCount, outputCount);
            return;
        }
        this.setState({ saveModalFlag: true });
    }
    //清空节点
    clearJsplumb = () => {
        let { processData } = this.state;
        let flag = processData.filter(item => item.deleted === false).length > 0
        console.log("processData=====",processData,processData.filter(item => item.deleted === false),flag)

        if(flag) {
            this.setState({ nowClickMyWorkflowPro: {} }, () => {
                try {
                    jsPlumbIn.empty("process-editor");
                    jsPlumbIn.deleteEveryConnection();
                    jsPlumbIn.deleteEveryEndpoint();
                } catch (error) {
                    console.log(error);
                    message.error("jsPlumbIn清除失败！请刷新页面！");
                }
            });
            processData.forEach(item => {
                item.deleted = true;
            });
            this.setState({ processData: processData })
        } else {
            this.setState({ nowClickMyWorkflowPro: {} })
        }
        // this.setState({ processData: [], nowClickMyWorkflowPro: {} }, () => {    
        // this.setState({ nowClickMyWorkflowPro: {} }, () => {
        //     try {
        //         jsPlumbIn.empty("process-editor");
        //         jsPlumbIn.deleteEveryConnection();
        //         jsPlumbIn.deleteEveryEndpoint();
        //     } catch (error) {
        //         console.log(error);
        //         message.error("jsPlumbIn清除失败！请刷新页面！");
        //     }
        // });
        // processData.forEach(item => {
        //     item.deleted = true;
        // });
        // this.setState({ processData: [] })
    }

    viewzoom = (e) => {
        let zoom = Math.pow(0.9, e.deltaY / 100) * this.state.zoom
        this.setState({ zoom: zoom })

    }

    deletenode = (uuid) => {
        let { processData } = this.state
        let node = processData.find((n) => n.uuid === uuid)
        node.deleted = true
        // let list = processData.filter((n) => n.uuid !== uuid)
        // jsPlumbIn.remove(uuid);
        this.setState({ processData })
    }

    // getnode = (uuid) => {
    //     let { processData } = this.state
    //     return processData.find((n) => n.uuid === uuid)
    // }

    onMouseDown = (e) => {
        let panel = document.getElementById('process-editor')
        let pl = panel.offsetLeft
        let pt = panel.offsetTop
        let initX = e.clientX;
        let initY = e.clientY;
        let _this = this
        this.setState({ dragable: true }, () => {
            document.addEventListener("mousemove", function (e) {
                if (_this.state.dragable === true) {
                    var nowX = e.clientX,
                        nowY = e.clientY,
                        disX = nowX - initX,
                        disY = nowY - initY;
                    // console.log(nowX, nowY);
                    panel.style.left = (pl + disX / _this.state.zoom) + "px";
                    panel.style.top = (pt + disY / _this.state.zoom) + "px";
                }
            });
        })
    }

    onMouseUp = () => {
        this.setState({ dragable: false })
    }

    /**
     * 渲染算法工具面板
     * @param page 当前页码
     * @param pagesize 页面的
     * @returns {unknown[]}
     */
    renderToolPanel = (page, pagesize, type) => {
        let size = 0;//计数
        let id = 1;//记录当前的tool的索引
        let tools = this.state.showTools.map((tool, index) => {
            if (tool.type !== type || size >= pagesize) {//如果当前的tool不是这类的 或者 当前页已经达到pagesize
                return;
            }
            if (id > (page - 1) * pagesize && id <= page * pagesize) {
                size++;
                return <CommonNodeTool key={index} dragstart={this.dragstart} tool={tool} />;
            }
            id++;
        });
        return tools;
    }

    renderToolPanelByAlgorithmTools = (typeList, typeSelectIndex, nowSelectToolsPageIndex, limitCount, className) => {
        if (!typeList[typeSelectIndex] || !typeList[typeSelectIndex].compontentList)
            return
        let size = 0;//计数
        let id = 1;//记录当前的tool的索引
        let tools = typeList[typeSelectIndex].compontentList.map((tool, index) => {
            if (size >= limitCount) {//如果当前的tool不是这类的 或者 当前页已经达到pagesize
                return;
            }
            if (id > (nowSelectToolsPageIndex - 1) * limitCount && id <= nowSelectToolsPageIndex * limitCount) {
                size++;
                return <CommonNodeTool key={index} dragstart={this.dragstart} tool={tool} className={className}
                    readerAlgorithmDetails={this.readerAlgorithmDetails} />;
            }
            id++;

        });
        return tools;
    }
    //算法组件详情
    readerAlgorithmDetails = (dataSource) => {
        let details = {}
        this.setState({ AlgorithmFlag: true })
        // details.algorithmName="";
        // details.algoirthmID="";
        // details.algorithmDesc="";
        details.algorithmName = dataSource.algorithmName;
        details.algoirthmID = dataSource.algoirthmID;
        details.algorithmDesc = dataSource.algorithmDesc;
        this.setState({ AlgorithmDetails: details })
    }
    renderTipToolByAlgorithm = (toolList) => {
        let tools = toolList.map((tool, index) => {
            return <CommonNodeTool key={index} dragstart={this.dragstart} tool={tool} />;
        });
        return tools;
    }

    /**
     * 获取type的tool的总的数量
     * @param type
     * @returns {number}
     */
    getToolTotalSize = (type) => {
        let totalSize = 0;//计数
        this.state.showTools.map((tool, index) => {
            if (tool.type !== type) {//如果当前的tool不是这类的
                return;
            }
            totalSize++;
        })
        return totalSize;
    }

    render() {
        const {
            topTypeSelect,
            nowClickMyWorkflowPro,
            searchValue,
            searchAssembly,
            saveModalFlag,
            publishModalFlag,
            deleteProModalFlag,
            flowChsName,
            flowEngName,
            algorithmTools,
            classSelectIndex,
            typeSelectIndex,
            nowSelectToolsPageIndex,
            limitCount,
            tipTools,
            AlgorithmFlag,
            AlgorithmDetails,
            tools,
            activeKeyOne,
            activeKeyTwo
        } = this.state;
        const { user } = this.props;

        return (<>
            {/*头部*/}
            <Header4 />

            {/*流程定制*/}
            <div className="processdesign-panel" onContextMenu={(e) => e.preventDefault()}>
                {/*左部*/}
                <div className={topTypeSelect === 1 ? 'process-left-panel' : 'process-left-panel process-left-panel-2'} >
                    <div
                        className={this.state.select === 1 ? 'process-left-top-1' : this.state.select === 2 ? 'process-left-top-2' : 'process-left-top-3'}>
                        <div className='Process_TopTitle'>
                            <div className='Process_TopTitle_Row'>
                                <div
                                    className={topTypeSelect === 1 ? 'Process_TopTitle_typeSelected' : 'Process_TopTitle_type'}
                                    onClick={() => this.changeTopTypeSelect(1)}>
                                    自定义流程
                                </div>
                                <div
                                    className={topTypeSelect === 2 ? 'Process_TopTitle_typeSelected' : 'Process_TopTitle_type'}
                                    onClick={() => this.changeTopTypeSelect(2)}>
                                    流程
                                </div>
                            </div>
                            <div className='Process_TopTitle_ButtonsRow'>
                                {topTypeSelect === 1 ?
                                    <Fragment>
                                        {/* <Button
                                            className={this.state.select === 1 ? 'process-left-top-btn-3_selected' : 'process-left-top-btn-3'}
                                            onClick={() => this.changeSelect(1)}>
                                            {'组件'}
                                        </Button> */}
                                        <div style={{ width: '100%'}}>
                                            <Input className="Process_TopTitle_Search" prefix={<SearchOutlined />} placeholder="检索算法相关组件" value={searchAssembly}
                                                onChange={(e) => this.setState({ searchAssembly: e.target.value })} onPressEnter={(e) => this.assemblySearch()}>
                                            </Input>
                                            {this.state.select == 1 && tools.length != 0 && <div className='process-left-tip'>{`本系统集成了6类24种算法共${tools.length - 2}个`}</div>}
                                        </div>
                                    </Fragment>
                                    :
                                    <Fragment>
                                        <Button
                                            className={this.state.select === 3 ? 'process-left-top-btn-3_selected' : 'process-left-top-btn-3'}
                                            onClick={() => this.changeSelect(3)}>
                                            {'我的流程'}
                                        </Button>
                                        <Button
                                            className={this.state.select === 2 ? 'process-left-top-btn-3_selected' : 'process-left-top-btn-3'}
                                            onClick={() => this.changeSelect(2)}>
                                            {'标准流程'}
                                        </Button>
                                        <Button
                                            className={this.state.select === 4 ? 'process-left-top-btn-3_selected' : 'process-left-top-btn-3'}
                                            onClick={() => this.changeSelect(4)}>
                                            {'公共流程'}
                                        </Button>
                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        this.state.select === 1 ?
                            //组件
                            <div className='process-tools-panel'>
                                {/* <div className='Process_Search'>
                                    <Input className='Process_Search_Input' placeholder='请输入算法名称' value={searchValue} onPressEnter={this.searchInfoByValue}
                                        onChange={(e) => this.setState({ searchValue: e.target.value })} />
                                    <Button className='Process_Search_Button' onClick={this.searchInfoByValue}>
                                        <img alt='' src={iconserach} className='iconserach' />
                                        <div>查询</div>
                                    </Button>
                                </div> */}
                                <Collapse className='process-tools-panel-collapse' accordion bordered={false}
                                    expandIconPosition={'right'}
                                    // expandIcon={({ isActive }) => <div style={{ color: '#0072e5' }}> {isActive ? '收起' : '展开'}</div>}
                                    onChange={this.changeCollapseAlgorithm}
                                    activeKey={activeKeyOne}
                                >
                                    <CollapsePanel key={0} header={<div className='process-tools-panel-header'>通用组件<span className='process-tools-panel-header-num'>{this.state.compontentList.length}</span></div>} className='process-tools-collapsepanel'>
                                        <div className='process-tools-collapse-p1'>
                                            {
                                                this.state.compontentList.map((tool, index) =>
                                                    <InOutNodeTool key={index} dragstart={this.dragstart}
                                                        tool={tool}></InOutNodeTool>)
                                            }
                                        </div>
                                    </CollapsePanel>
                                    <CollapsePanel key={1} header={<div className='process-tools-panel-header'>可用组件<span className='process-tools-panel-header-num'>{tipTools.length}</span></div>} className='process-tools-collapsepanel'>
                                        <div className='process-tools-collapse-toolpanel'>
                                            {this.renderTipToolByAlgorithm(tipTools)}
                                        </div>
                                    </CollapsePanel>
                                    {algorithmTools.map((classList, index) => {
                                        return (
                                            <CollapsePanel key={index + 2} header={<div className='process-tools-panel-header'>{classList.className}<span className='process-tools-panel-header-num'>{classList.count}</span></div> || "未知"}
                                                className='process-tools-collapsepanel'>
                                                {/* <div className='process-tools-collapse-swapper'> */}
                                                    <Collapse activeKey={activeKeyTwo} className="process-tools-collapsepanel-child" accordion expandIconPosition={'right'} onChange={this.changeLightTools}>
                                                        {classList.typeList.map((type,i) => {
                                                            return (
                                                                <CollapsePanel className="process-tools-collapsepanel-child-header" key={i} header={<div className='process-tools-panel-child-header'>{type.typeName ? type.typeName : "默认"}<span className='process-tools-panel-header-num'>{type.compontentList.length}</span></div> || "未知"}>
                                                                        <div className='process-tools-collapse-toolpanel'>
                                                                            <div className='process-tools-collapse-toolpanel-content'>{this.renderToolPanelByAlgorithmTools(classList.typeList, typeSelectIndex, nowSelectToolsPageIndex, limitCount,classList.className)}</div>
                                                                            <Pagination className='process-tools-pagination' defaultCurrent={1}
                                                                                pageSize={limitCount}
                                                                                total={this.returnToolsTotal(classList, typeSelectIndex)}
                                                                                showSizeChanger={false}
                                                                                onChange={(page, pageSize) => this.setState({ nowSelectToolsPageIndex: page })} />
                                                                        </div>
                                                                    </CollapsePanel>
                                                                //     <div
                                                                //     className={`process-tools-collapse-tab2  ${typeSelectIndex === index ? 'tab-active' : ''}`}
                                                                //     onClick={() => this.changeLightTools(index)}>
                                                                //     {`${type.typeName ? type.typeName : "默认"}（${type.compontentList.length}）`}
                                                                // </div>
                                                            )
                                                        })}
                                                    </Collapse>
                                                {/* </div> */}
                                                
                                            </CollapsePanel>
                                        )
                                    })}

                                </Collapse>
                            </div> :
                            //我的流程
                            <div className='process-mypro-panel'>
                                <div className='process-mypro-search-panel'>
                                    <Input placeholder="检索相关流程" className="Process_TopTitle_Search" prefix={<SearchOutlined />} value={searchValue}
                                        onChange={(e) => this.setState({ searchValue: e.target.value })}
                                        onPressEnter={(e) => this.pressSearch()}></Input>
                                    <div className='process-mypro-search-panel-choose'>
                                        产品品种：
                                        <Cascader onChange={(value)=>{
                                            this.setState({variety:value})
                                        }} bordered={false} placeholder="请选择产品品种" options={algProduceTypeOptionsSimple}></Cascader>
                                        <Button type="primary" onClick={this.pressSearch}>检索</Button>
                                    </div>
                                    
                                </div>
                                <div className='process-mypro-table'>
                                    <div className='process-mypro-table-header'>
                                        <div className='process-mypro-table-index'>序号</div>
                                        <div className='process-mypro-table-text1'>流程名称</div>
                                        {this.state.select === 4 ?
                                            <div className='process-mypro-table-text1-0'>发布者</div>
                                            : null}
                                        <div className='process-mypro-table-text2'>操作</div>
                                    </div>
                                    <div className='process-mypro-table-body'>
                                        {this.state.select === 2 ?      //标准流程
                                            this.state.standardpro.map((pro, index) => {
                                                // console.log("publicpro", pro,pro.userID, user,user.userID);
                                                return (<div className='process-mypro-table-row'>
                                                    <div className='process-mypro-table-index'>{(index + 1) + ((this.state.pageNo - 1)* 15)}</div>
                                                    <div className='process-mypro-table-proname'>{pro.flowchsname}</div>
                                                    {/* <div className='process-mypro-table-proname2'>{pro.userName}</div> */}
                                                    <div className='process-mypro-table-operation'>
                                                        <div className='process-mypro-table-edit'
                                                            onClick={() => this.editMyProByWorkflow(pro)}>
                                                            {/* {user.userId === pro.userID ? "编辑" : "查看"} */}
                                                            查看
                                                        </div>
                                                        {/* 标准流程记得之后取消删除入口 */}
                                                        {/* {user.userId === pro.userID ?
                                                            <div className='process-mypro-table-del' onClick={() => this.deleteProModal(pro)}>删除</div>
                                                            : null} */}
                                                    </div>
                                                </div>)
                                            })
                                            :
                                            this.state.select === 3 ?   //我的流程
                                                this.state.mypro.map((pro, index) => {
                                                    return (<div className='process-mypro-table-row'>
                                                        <div className='process-mypro-table-index'>{(index + 1) + ((this.state.pageNo - 1)* 15)}</div>
                                                        <div
                                                            className='process-mypro-table-proname'>{pro.flowchsname}</div>
                                                        <div className='process-mypro-table-operation'>
                                                            <div className='process-mypro-table-edit'
                                                                onClick={() => this.editMyProByWorkflow(pro)}>编辑
                                                            </div>
                                                            <div className='process-mypro-table-edit'
                                                                onClick={() => this.openPublishModal(pro)}>发布
                                                            </div>
                                                            <div className='process-mypro-table-del'
                                                                onClick={() => this.deleteProModal(pro)}>删除
                                                            </div>
                                                        </div>
                                                    </div>)
                                                })
                                                :
                                                this.state.publicpro.map((pro, index) => {    //公共流程
                                                    // console.log("publicpro", pro,pro.userID, user,user.userID);
                                                    return (<div className='process-mypro-table-row'>
                                                        <div className='process-mypro-table-index'>{(index + 1) + ((this.state.pageNo - 1)* 15)}</div>
                                                        <div
                                                            className='process-mypro-table-proname'>{pro.flowchsname}</div>
                                                        <div className='process-mypro-table-proname2'
                                                            title={pro.flowauthor}>{this.returnLessName(pro.flowauthor, 12)}</div>
                                                        <div className='process-mypro-table-operation'>
                                                            <div className='process-mypro-table-edit'
                                                                onClick={() => this.editMyProByWorkflow(pro)}>
                                                                {user.userId === pro.userID ? "编辑" : "查看"}
                                                            </div>

                                                            {user.userId === pro.userID ?
                                                                <div className='process-mypro-table-del'
                                                                    onClick={() => this.deleteProModal(pro)}>删除</div>
                                                                : null}
                                                        </div>
                                                    </div>)
                                                })
                                        }
                                    </div>
                                    <Pagination className='process-mypro-table-body-pagination'
                                        onChange={this.proPageChange} total={this.state.total}
                                        current={this.state.pageNo} pageSize="15" showSizeChanger={false} size='small' />
                                </div>
                            </div>
                    }
                </div>
                {/*右部*/}
                <div className='process-right-panel'>
                    {/* <div className='process-editor-title-panel' onClick={() => { this.setState({ attributeopen: !this.state.attributeopen }) }}> */}
                    <div className='process-editor-title-panel'>
                        {'流程图 >>'}
                        {/* <Button onClick={this.test}>测试</Button> */}
                    </div>
                    <div className='process-editor-attribute-container'
                        style={{ height: this.state.attributeopen ? window.innerHeight - 64 - 56 : 0 }}>
                        <div className='process-editor-attribute-panel'>
                            <div className='process-editor-attribute-line1'>

                            </div>
                            <div className='process-editor-attribute-line2'>

                            </div>
                            <div className='process-editor-attribute-line3'>

                            </div>
                        </div>
                    </div>
                    <div className='process-editor-panel-container'>
                        {/* {(!nowClickMyWorkflowPro.userID || nowClickMyWorkflowPro.userID === user.userId) && this.state.select !== 2 ? */}
                        {(!nowClickMyWorkflowPro.userID || nowClickMyWorkflowPro.userID === user.userId) && this.state.select !== 2 ?
                            <Fragment>
                                <Button className='proecss-editor-save-btn'
                                    onClick={() => this.breforeSave()}>
                                    保存
                                </Button>
                                <Button className='proecss-editor-clear-btn'
                                    onClick={() => this.clearJsplumb()}>
                                    清空
                                </Button>
                            </Fragment>
                            : null}
                        <div className='process-editor-panel' id='process-editor'
                            onMouseUp={this.onMouseUp}
                            onMouseDown={this.onMouseDown}
                            onWheel={this.viewzoom}
                            onDragOver={(e) => {
                                e.preventDefault()
                            }}
                            onDrop={this.dropitem}>
                            {this.state.processData.map((node, index) => {
                                return this.getNode(node)
                            })}
                        </div>
                    </div>
                    <Modal className="AlgorithmDetails-panel" visible={AlgorithmFlag} title={"算法详情"}
                        footer={null} maskClosable={true} centered
                        onCancel={() => this.setState({ AlgorithmFlag: false })}>
                        <div className='AlgorithmDetails-body'>
                            <div className='AlgorithmDetails-content'>
                                <span
                                    className='AlgorithmDetails-content-title'>算法名称 ： </span>{AlgorithmDetails.algorithmName}
                            </div>
                            <div className='AlgorithmDetails-content'>
                                <span
                                    className='AlgorithmDetails-content-title'>算法id ：</span>{AlgorithmDetails.algoirthmID}
                            </div>
                            <div className='AlgorithmDetails-content'>
                                <span
                                    className='AlgorithmDetails-content-title'>算法描述 ：</span>{AlgorithmDetails.algorithmDesc}
                            </div>
                        </div>

                    </Modal>
                    <Modal visible={saveModalFlag} title={"流程定制保存"} footer={this.returnSaveFooter()}
                        onOk={this.saveAxios} onCancel={() => this.setState({ saveModalFlag: false })}
                        closable={false}>
                        <div className='proecss-saveModal-content'>
                            <div className='proecss-saveModal-content-row'>
                                <div className='proecss-saveModal-content-row-text'>流程中文名称：</div>
                                <Input className='proecss-saveModal-content-row-input' value={flowChsName}
                                    onChange={(e) => this.setState({ flowChsName: e.target.value })}
                                    placeholder="请输入流程中文名称" />
                            </div>
                            <div className='proecss-saveModal-content-row'>
                                <div className='proecss-saveModal-content-row-text'>流程英文名称：</div>
                                <Input className='proecss-saveModal-content-row-input' value={flowEngName}
                                    onChange={(e) => this.setState({ flowEngName: e.target.value })}
                                    placeholder="请输入流程英文名称" />
                            </div>
                        </div>
                    </Modal>
                    <Modal visible={publishModalFlag} title={"个人流程发布"}
                        onOk={this.publishMyPro} onCancel={() => this.setState({ publishModalFlag: false })}
                        closable={false}>
                        {`是否确认发布${this.state.nowClickMyWorkflowPro.flowchsname}流程到公共流程?`}
                    </Modal>
                    <Modal visible={deleteProModalFlag} title={"删除流程"}
                        onOk={this.deleteWorkflowPro} onCancel={() => this.setState({ deleteProModalFlag: false })}
                        closable={false}>
                        {`是否确认删除${this.state.nowClickMyWorkflowPro.flowchsname}流程?`}
                    </Modal>
                </div>
                {/*属性*/}
                <div className='rootback' style={{ display: this.state.contextmenuopen ? 'block' : 'none' }}
                    onMouseDown={(e) => {
                        console.log('点击了背景');
                        e.preventDefault();
                        this.setState({ contextmenuopen: false });
                    }}>
                    <ContextMenu
                        node={this.state.current_node_name}
                        close={() => this.setState({ contextmenuopen: false })}
                        ondeletenode={this.deletenode}
                        ref={ref => this.contextmenu = ref}
                        target={this.state.rightclickitem}
                        removePoint={this.removePoint}
                    />
                </div>
            </div>
        </>)
    }

    //检索算法组件（之后考虑同一时间只能打开一个类别，以此限定检索值和算法，使其浓缩且不会冲突）
    //根据关键词，在本地检索算法
    searchInfoByValue = () => {
        const { algorithm, tools, searchValue, defaultData, standardData, privateData, publicData } = this.state;
        if (!searchValue || searchValue === "") {
            this.setState({ showTools: [...tools] });
            return;
        }
        let showData = [];
        showData = tools.filter((data) => data.name.includes(searchValue) && data.type !== "common");
        console.log("searchInfoByValue", tools, showData);
        // if (algorithm === '算法') {
        //     showData = defaultData.filter((data) => data.name.includes(searchValue));
        // }
        // else if (algorithm === '标准流程') {
        //     showData = standardData.filter((data) => data.name.includes(searchValue));
        // }
        // else if (algorithm === '我的流程') {
        //     showData = privateData.filter((data) => data.name.includes(searchValue));
        // }
        // else if (algorithm === '公共流程') {
        //     showData = publicData.filter((data) => data.name.includes(searchValue));
        // }
        // else {
        // }
        this.setState({ showTools: [...showData] });
    }
    removePoint = (ele) => {
        const { processData } = this.state;
        let list = processData.filter((data) => data.id !== ele.id);
        jsPlumbIn.deleteEndpoint(ele.uuid + "-source");
        jsPlumbIn.deleteEndpoint(ele.uuid + "-target");
        this.setState({ processData: list });
    }

    returnLessName = (name, lenNum) => {
        if (name.length > lenNum) {
            let returnName = name;
            returnName = name.slice(0, lenNum - 3) + "...";
            return returnName;
        } else
            return name;
    }
    //组件中切换类型算法时
    changeCollapseAlgorithm = (e) => {
        console.log("changeCollapseAlgorithm", e);
        this.setState({ activeKeyOne: [e] });
        this.changeLightTools(0)
    }

    changeSelect = (num) => {
        // this.clearJsplumb();
        this.setState({ select: num, searchValue: "", }, () => {
            this.pressSearch();
        });
    }
    changeTopTypeSelect = (num) => {
        if (num === 1) {
            this.changeSelect(1);
            // this.setState({ nowClickMyWorkflowPro: {} });
        } else if (num === 2) {
            this.changeSelect(3);
        }
        // this.clearJsplumb();
        this.setState({ topTypeSelect: num, });
    }

    cancelModal = () => {
        this.setState({ saveModalFlag: false });
    }
    returnSaveFooter = () => {
        return (
            <Fragment>
                <Button onClick={() => this.cancelModal()}>取消</Button>
                {/* <Button type="primary" onClick={this.saveAxios_standard} >保存为标准流程</Button> */}
                <Button type="primary" onClick={this.saveAxios}>保存</Button>
            </Fragment>
        )
    }


    returnToolsTotal = (classList, typeSelectIndex) => {
        if (!classList.typeList[typeSelectIndex] || !classList.typeList[typeSelectIndex].compontentList)
            return 0;
        return classList.typeList[typeSelectIndex].compontentList.length;
    }

    // //光学算法平台、公共、个人组件切换
    // changeLightTools=(num)=>{
    //     this.setState({tooltabactive:num});
    //     if(num===1){//平台
    //         this.setState({tools: defaulttools,})
    //     }else if(num===2){//公共
    //         this.setState({tools: [],})
    //     }
    //     else if(num===3){//个人
    //         this.setState({tools: [],})
    //     }
    // }
    //光学算法类型切换
    changeLightTools = (num) => {
        console.log("changeLightTools", num);
        const { tools } = this.state;
        this.setState({ tooltabactive: num, typeSelectIndex: num, nowSelectToolsPageIndex: 1 ,activeKeyTwo:[num]});
        // if (num === 1) {//平台
        //     this.setState({ showTools: tools, })
        // } else if (num === 2) {//公共
        //     this.setState({ showTools: [], })
        // } else if (num === 3) {//个人
        //     this.setState({ showTools: [], })
        // } else if (num === 4) {//个人
        //     this.setState({ showTools: [], })
        // } else if (num === 5) {//个人
        //     this.setState({ showTools: [], })
        // } else if (num === 6) {//个人
        //     this.setState({ showTools: [], })
        // }
    }
    //微波算法类型切换
    changeMicrowaveTools = (num) => {
        this.setState({ microwaveTooltabactive: num });
        if (num === 1) {//平台
            this.setState({ showTools: [], })
        } else if (num === 2) {//公共
            this.setState({ showTools: [], })
        } else if (num === 3) {//个人
            this.setState({ showTools: [], })
        } else if (num === 4) {//个人
            this.setState({ showTools: [], })
        } else if (num === 5) {//个人
            this.setState({ showTools: [], })
        } else if (num === 6) {//个人
            this.setState({ showTools: [], })
        }
    }

    //给流程content排序
    returnSortContent = (saveprocess) => {
        let list = [];
        let input = {};
        saveprocess.map((node) => {
            if (node.toolId === 0)
                input = node;
        })
        let nowNode = JSON.parse(JSON.stringify(input));
        while (nowNode.targetNodes[0] !== undefined) {
            saveprocess.map((node) => {
                if (node.uuid === nowNode.targetNodes[0]) {
                    list.push(nowNode);
                    nowNode = node;
                }
            })
        }
        list.push(nowNode);
        return list;
    }
}

// *******************************************************************
// *******   *********   *****   ********   **  *********   **   *****
// *******   *********  *          **                ****   **   *****
// ******   *********        *     **                *****  **  ******
// *               **  ***   *     ******   **  *  ****            ***
// ******   ********   ***          **             ****   **  **   ***
// *****   **********       **     ***** **   **   ****            ***
// *****   ***********  *          ****   *   *    ****            ***
// ****           ****  ***  *   *******      *   *****   **  **   ***
// ***    *****   ***     *        ********   *********            ***
// **     *****   ****  *    *   ****                *******  ********
// *      *****   ****             ******       ************  ********
// *      *****   ****       *   *******          ***                *
// ****           ****           ******   *   *     ********  ********
// ****           ****     *        *    **   ***    *******  ********
// ****   *****   ******   ****************   **************  ********
// *******************************************************************
class ContextMenu extends React.Component {

    state = {
        isAlgorithmModalShow: false,//控制算法信息编辑弹窗的显隐
    }

    getIndex = (event) => {
        // console.log(event.target)
        let chosedIndex = event.target.attributes["index"].nodeValue;
        console.log(chosedIndex)
        this.setState({
            selectedIndex: chosedIndex
        })
    }

    clearVisibleStatus = () => {
        this.setState({
            isAlgorithmModalShow: false
        })
    }

    render() {
        let menu = []
        let { element, type } = this.props.target;

        /**
         * 算法的名字
         */
        let { node } = this.props;
        let algCompt = {};
        if (element && element.dataSource) algCompt = element.dataSource;
        switch (type) {
            case 'connectline':
                menu = [
                    {
                        text: '删除连接线',
                        action: () => {
                            jsPlumbIn.deleteConnection(element)
                            this.props.close()
                        }
                    }
                ]
                break;
            case 'node':
                if (element.type === 'common') {
                    menu = [
                        {
                            text: '删除节点',
                            action: () => {
                                // jsPlumbIn.remove(element.id)
                                this.props.removePoint(element);
                                this.props.close()
                            }
                        },
                    ]
                } else {
                    menu = [
                        {
                            text: '删除节点',
                            action: () => {
                                this.props.ondeletenode(element.uuid)
                                jsPlumbIn.remove(element.id)
                                // this.props.removePoint(element);
                                this.props.close()
                            }
                        },
                        {
                            text: '查看算法信息',
                            action: () => {
                                this.setState({
                                    isAlgorithmModalShow: true
                                })
                            }
                        }
                    ]
                }
                break;
            default:
                break;
        }

        let modal;
        switch (node) {
            case "水体透明度产品算法":
                modal = "WaterTransparency"
        }

        return (
            <>
                <div className='process-contextmenu'>
                    {menu.map((item, index) =>
                        <div onClick={item.action} key={index} onMouseDown={(e) => {
                            e.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                        }} className='process-contextmenu-item'>{item.text}</div>
                    )}
                </div>

                {/*<NumberParams isVisible={this.state.isAlgorithmModalShow} clearVisibleStatus={this.clearVisibleStatus} />*/}
                {/*<PictureParams isVisible={this.state.isAlgorithmModalShow} clearVisibleStatus={this.clearVisibleStatus}/>*/}

                {/*Modal:对话框， */}
                <Modal className="process-algorithm-modal"
                    visible={this.state.isAlgorithmModalShow}>{/* visible:是否可视 */}
                    {/*标题，关闭按钮*/}
                    <div className="process-algorithm-modal-title">
                        <div className="process-algorithm-modal-title-text">{node}</div>
                        <img className="process-algorithm-modal-close" src={closeIcon} onClick={() => {
                            this.clearVisibleStatus()
                        }} />{/* clearVisibleStatus:设置不可视 */}
                    </div>
                    <div className="process-algorithm-modal-scroll">
                        <div className='Process_AlgorithmDetaiilContent'>
                            <div className='Process_AlgorithmDetaiilContent_Title1'>算法名称</div>
                            <div className='Process_AlgorithmDetaiilContent_Text'>{algCompt.chsName}</div>
                            <div className='Process_AlgorithmDetaiilContent_Text'>IWPHPI-2m8m_华科_1.0</div>
                            <div className='Process_AlgorithmDetaiilContent_Title'>从属分类</div>
                            <div className='Process_AlgorithmDetaiilContent_Text'>{algCompt.algorithmClass}</div>
                            <div className='Process_AlgorithmDetaiilContent_Title'>作者</div>
                            <div className='Process_AlgorithmDetaiilContent_Text'>{algCompt.author}</div>
                            <div className='Process_AlgorithmDetaiilContent_Title'>版本</div>
                            <div className='Process_AlgorithmDetaiilContent_Text'>{algCompt.version}</div>
                            <div className='Process_AlgorithmDetaiilContent_Title'>算法简介</div>
                            <div
                                className='Process_AlgorithmDetaiilContent_Text'>{`${algCompt.chsName}算法，具体考察${algCompt.chsName}。`}</div>
                            <div className='Process_AlgorithmDetaiilContent_Title'>算法输入参数</div>
                            <div className='Process_AlgorithmDetaiilContent2'>
                                {algCompt && algCompt.aPamas && algCompt.aPamas.map((parameterData, index2) => {
                                    return (
                                        <div className='Process_AlgorithmDetaiilContent_Text' key={index2 + '-2'}>
                                            {`参数${index2 + 1}：${parameterData.paraChsName}`}
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='Process_AlgorithmDetaiilContent_Title'>算法输出参数</div>
                            <div className='Process_AlgorithmDetaiilContent2'>
                                {algCompt && algCompt.outputs && algCompt.outputs.map((parameterData, index2) => {
                                    return (
                                        <div className='Process_AlgorithmDetaiilContent_Text' key={index2 + '-2'}>
                                            {`参数${index2 + 1}：${parameterData.paraChsName}`}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </Modal>

            </>
        )
    }
}

// **********************************
// **             *****          ****
// *******   **********   *****  ****
// *******   **********          ****
// *******   **********   *****  ****
// *******   **********          ****
// *******   **********   *****  ****
// *******   **********          ****
// *******   **********   *****  ****
// *******   **********   *****  ****
// *******   *******                *
// *******   ***********   **   *****
// *                ***     *     ***
// ******************    *******   **
// ******************* **************
/**
 * 输入输出 组件
 * @param {*} props
 */
const InOutNodeTool = (props) => {
    const ondragstart = (e) => {
        // console.log('ondragstart',)
        props.dragstart(props.tool)
    }

    return (
        <div className='process-tool-input' draggable='true' onDragStart={ondragstart}>
            <img src={require('../resources/算法.png')} draggable={false}></img>
            <div className='process-tool-input-inside' >
                {
                    props.tool.name === "Inputs" ? "输入" : "输出"
                }
            </div>
        </div>
    )

}

/**
 * 三级  通用 组件
 * @param {*} props
 */
const CommonNodeTool = (props) => {
    const ondragstart = (e) => {
        // console.log('ondragstart')
        props.dragstart(props.tool)
    }
    const onreaderAlgorithmDetails = () => {
        props.readerAlgorithmDetails(props.tool.dataSource)
    }
    return (
        <div className='process-tool-common' draggable='true' onDragStart={ondragstart}
            onClick={onreaderAlgorithmDetails}>
            <div className='process-tool-common-icon-panel'>
                {/* <div className='process-tool-common-icon-lefttop'></div>
                <div className='process-tool-common-icon-leftbottom'></div>
                <div className='process-tool-common-icon-righttop'></div>
                <div className='process-tool-common-icon-rightbottom'></div> */}
                <img className='process-tool-common-icon' alt='' draggable={false} src={switchImage(props.className)} />
            </div>
            <div className='process-tool-common-text-panel'>
                <div className='process-tool-common-name-panel'>

                    {props.tool.name === ("Inputs" || "Outputs") ?
                        props.tool.name === "Inputs" ? "输入" : "输出"
                        :
                        props.tool.name
                    }
                </div>
                <div className='process-tool-common-score-panel'>
                    {/*{'98'}*/}
                </div>
            </div>
        </div>
    )

}

const switchImage = (className) => {
        console.log(className)
        let imgUrl = ''
        switch(className) {
            case '辐射类产品':
                imgUrl = require('../resources/radiation.png')
                break
            case '植被类产品':
                imgUrl = require('../resources/vegetation.png')
                break
            case '大气类产品':
                imgUrl = require('../resources/atmosphere.png')
                break
            case '陆表类产品':
                imgUrl = require('../resources/landSurface.png')
                break
            case '水体类产品':
                imgUrl = require('../resources/wave.png')
                break
            case '几何类产品':
                imgUrl = require('../resources/geometry.png')
                break
            default: 
                imgUrl = require('../resources/算法.png')
                break
        }
        return imgUrl
}

// *****   *   ***********   ********
// *****   *   ***********   ********
// *               *******         **
// *****   *   ***********   ********
// *****   *   ***********   ********
// *******************            ***
// *              ****   ******   ***
// ******   ****  ****   ******   ***
// ******   ***   ****   ******   ***
// ******   ***   ****            ***
// ******   ***   *******************
// ******   *     ***      *   *   **
// ******   *********   *      *   **
// ******   *********   *   *   *   *
// ******   ********   **********  **
/**
 * 开始、结束  节点
 * @param {*} props
 */
const InOutNode = (props) => {
    return (
        <div className='process-node-input' id={props.node.id} onContextMenu={(originalEvent) => {
            console.log(originalEvent)
            props.onContextMenu(props.node, { x: originalEvent.clientX, y: originalEvent.clientY }, 'node')
        }}
        >
            <div className='process-node-input-inside'>
                {props.node.name === "Inputs" || props.node.name === "Outputs" ?
                    props.node.name === "Inputs" ? "输入" : "输出"
                    :
                    props.node.name
                }
            </div>
        </div>
    )
}

/**
 * 通用节点
 * @param {*} props
 */
const CommonNode = (props) => {
    console.log(props.node)
    return (
        <div className='process-node-common' id={props.node.id}
            onContextMenu={(originalEvent) => {
                props.onContextMenu(props.node, { x: originalEvent.clientX, y: originalEvent.clientY }, 'node')
            }}>
            <div className='process-node-common-icon'>
                <img alt='' src={switchImage(props.node.dataSource.algorithmClass.split('_')[0])} className='process-node-common-icon-img'></img>
            </div>
            <div className='process-node-common-text'>
                {props.node.dataSource.chsName}
                {/* {props.node.name} */} 
            </div>
        </div>
    )
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})
const mapDispatch = (dispatch, ownProps) => ({})

export default connect(mapState, mapDispatch)(ProcessDesign);

/**
 * 代表流程定制节点类
 *
 */
class ProcessNode {
    /**
     * 算法模型ID
     */
    toolId: String
    /**
     * 位置
     */
    left: Number
    /**
     * 位置
     */
    top: Number
    /**
     * 算法名称
     */
    name: String
    /**
     * 唯一标识符 用来标记 这个节点的身份  相当于身份证
     */
    uuid: String
    /**
     * 唯一标识符 仅显示用 就是元素的id ，为了满足多次加载需求  ，相当于称呼，同样的元素 不同时间加载会给与不同的称呼
     *  */
    id: String
    /**
     *节点类型 按照工具类型来的 ，用来对显示的图形进行区分
     */
    type: String
    /**
     * 删除标志位
     */
    deleted: Boolean = false
    /**
     * 连接的下一个节点 只放ID
     */
    targetNodes: String[] = []

}




